(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-products-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const section = document.querySelector('[data-testid^="featured-products-tabs-"]');
    if (!section) return;

    const tabs = section.querySelectorAll('.featured-products-tabs__tab');
    const panels = section.querySelectorAll('.featured-products-tabs__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        const index = this.getAttribute('data-tab-index');

        tabs.forEach(function (t) {
          t.classList.remove('featured-products-tabs__tab--active');
          t.setAttribute('aria-selected', 'false');
        });

        panels.forEach(function (p) {
          p.classList.remove('featured-products-tabs__panel--active');
          p.setAttribute('hidden', '');
        });

        this.classList.add('featured-products-tabs__tab--active');
        this.setAttribute('aria-selected', 'true');

        const target = section.querySelector(
          '.featured-products-tabs__panel[data-tab-index="' + index + '"]'
        );
        if (target) {
          target.classList.add('featured-products-tabs__panel--active');
          target.removeAttribute('hidden');
        }
      });
    });

    /* Keyboard navigation for accessibility */
    tabs.forEach(function (tab, i) {
      tab.addEventListener('keydown', function (e) {
        var newIndex;
        if (e.key === 'ArrowRight') {
          newIndex = (i + 1) % tabs.length;
        } else if (e.key === 'ArrowLeft') {
          newIndex = (i - 1 + tabs.length) % tabs.length;
        } else {
          return;
        }
        e.preventDefault();
        tabs[newIndex].focus();
        tabs[newIndex].click();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
